import React from "react";
import Select from 'react-select';
import { FormFeedback } from 'reactstrap';

/**
 *
 * @param label
 * @param name
 * @param formik
 * @param options
 * @param placeholder
 * @param showValidation
 * @param onChangeOverride
 * @param classNamePrefix
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 *
 * Usage Example
 * <SelectBox
 *   label="Customer Name"
 *   name="customerName"
 *   formik={customerDetailsFormik}
 *   options={customerNameLists}
 *   placeholder="Select Customer"
 *   onChangeOverride={(e, formik) => {
 *
 *   }}
 * />
 */


const SelectBox = ({label, name, formik, options = [], placeholder = 'Select...', showValidation = true,
                       onChangeOverride, classNamePrefix = 'select2-selection form-select', ...rest }) => {
    const {values, setFieldValue, setFieldTouched, touched, errors, handleBlur} = formik;

    const hasError = showValidation && touched[name] && !!errors[name];

    const handleChange = (selectedOption) => {
        if (onChangeOverride) {
            onChangeOverride(selectedOption, formik);
        } else {
            setFieldValue(name, selectedOption);
        }
    };
    const rawValue = values[name];
    const selectedOption = options?.find(
        (opt) => opt.value === rawValue?.value || opt.value === rawValue
    );

    return(
        <>
            {label && <label className="form-label" htmlFor={name}>{label}</label>}
            <Select
                name={name}
                id={name}
                options={options}
                value={selectedOption || ''}
                onChange={handleChange}
                onBlur={(e) => {
                    setFieldTouched(name, true);
                    handleBlur(e);
                }}
                placeholder={placeholder}
                classNamePrefix={classNamePrefix}
                {...rest}
            />
            {hasError && (
                <FormFeedback className="d-block">
                    {errors[name]?.label || errors[name]}
                </FormFeedback>
            )}
        </>
    );
}

export default SelectBox;
